module.exports = __webpack_public_path__ + "img/broom.c0109f59.png";